
  import { css } from 'lit';
  export const styles = css`:host{--background: var(--ig-avatar-background, var(--ig-gray-200));--ig-theme: material;--ig-theme-variant: dark}`;
  